import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Pillars from "@/components/site/Pillars";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Process from "@/components/site/Process";
import Industries from "@/components/site/Industries";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

export default function Landing() {
  useEffect(() => {
    document.title =
      "CyberCart | Website Development | AI Automation Agency India";
    const m = document.querySelector('meta[name="description"]');
    const content =
      "CyberCart is a digital growth and automation agency. We build websites, WordPress and WooCommerce stores, SEO, CRM, WhatsApp automation, AI workflows, and lead generation systems for growing businesses across India.";
    if (m) m.setAttribute("content", content);
    else {
      const tag = document.createElement("meta");
      tag.name = "description";
      tag.content = content;
      document.head.appendChild(tag);
    }
  }, []);

  return (
    <div data-testid="landing-root" className="min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Pillars />
        <Services />
        <WhyUs />
        <Process />
        <Industries />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
